var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uploading-wrapper",class:{ 'block-page': _vm.blockPage, big: !_vm.smallLoader }},[_c('span',{staticClass:"loader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }